export const T_NAMESPACE_COMMON = 'common';
export const T_NAMESPACE_DISCOVER = 'discover';
export const T_NAMESPACE_GENRES = 'genres';
export const T_NAMESPACE_SHOWS = 'shows';
export const T_NAMESPACE_SEARCH = 'search';